const \uC77C\uBC18_\uBC88\uD638 = /^(02|0[3-6][0-5])-?([0-9]{1}[0-9]{2,3})-?([0-9]{4})/;
const \uD734\uB300\uD3F0_\uBC88\uD638 = /^(01[01346-9])-?([0-9]{1}[0-9]{2,3})-?([0-9]{4,8})/;
const \uC778\uD130\uB137_\uC804\uD654_\uBC88\uD638_070_080 = /^((?:(0[7-8]0)-?([0-9]{3,4})|(1[1-9]{3}))-?([0-9]{4}))/;
const \uC778\uD130\uB137_\uC804\uD654_\uBC88\uD638_050 = /^(050\d)-?(\d{4})-?(\d{4})/;
const CONTACT_NUMBER_REGEX = new RegExp(
  `${\uC77C\uBC18_\uBC88\uD638.source}$|${\uC778\uD130\uB137_\uC804\uD654_\uBC88\uD638_070_080.source}$|${\uC778\uD130\uB137_\uC804\uD654_\uBC88\uD638_050.source}$|${\uD734\uB300\uD3F0_\uBC88\uD638.source}$`
);

export { CONTACT_NUMBER_REGEX };
//# sourceMappingURL=regex.mjs.map
